import { useSession } from './context/SessionContext';
import { LoginScreen } from './features/auth/LoginScreen';
import { EmployeeShell } from './features/employee/EmployeeShell';
import { ManagerShell } from './features/manager/ManagerShell';
import { FaleConoscoButton } from './components/FaleConoscoButton';

export function App() {
  const { session } = useSession();

  if (!session) return <LoginScreen />;
  return (
    <>
      {session.role === 'employee' ? <EmployeeShell /> : <ManagerShell />}
      <FaleConoscoButton />
    </>
  );
}
